import { Action } from '@ngrx/store';

export enum ResourceActionsTypes {
  UPDATE_RESOURCE = '[RESOURCE] update'
}

export enum StoreSelect {
  RESOURCES = 'resources'
}

export class UpdateResourceAction implements Action {
  readonly type = ResourceActionsTypes.UPDATE_RESOURCE;

  constructor(public payload: any) {}
}

export type ResourceAction = UpdateResourceAction;
